import { useRoutes } from "react-router-dom";
import { lazy, Suspense } from "react";
import { i18n } from "../../localization/i18n";
import { Loading } from "../../components/Loading";
import Layout from "../../components/Layout";
import StandardSolutionsList from "../../modules/creators/pages/StandardSolutionsList";
import CreateSolution from "../../modules/creators/pages/CreateSolution";
import EditSolution from "../../modules/creators/pages/EditSolution";
import { Orders } from "../../modules/Orders";
import MakeSolution from "../../modules/creators/pages/MakeSolution";
import NotFound from "./NotFound";
import SolutionsCreator from "../../modules/creators/pages/SolutionsCreator";
import Solutions from "../../modules/Solutions";
import MultiStandardSolutionsUpload from "../../modules/creators/pages/MultiStandardSolutionsUpload";

const Dashboard = lazy(() =>
  import("../../modules/Dashboard").then((module) => ({ default: module.Dashboard }))
);


function CreatorsRoutes() {
  const creatorRoutes = useRoutes([
    {
      path: '/creators/dashboard',
      element: (
        <Layout>
          <Suspense
            fallback={
              <Loading
                loading={true}
                text={`${i18n.t("login.starting")}`}
                numberOfDots={3}
                dotSymbol="."
                global={false}
              />
            }
          >
            <Dashboard />
          </Suspense>
        </Layout>
      )
    },
    {
      path: '/creators/solutions',
      element: (
        <Layout>
          <Solutions />
        </Layout>
      )
    },
    {
      path: '/creators/solutions_old',
      element: (
        <Layout>
          <SolutionsCreator />
        </Layout>
      )
    },
    {
      path: '/creators/solutions/create',
      element: (
        <Layout>
          <CreateSolution />
        </Layout>
      )
    },
    {
      path: '/creators/solutions/edit',
      element: (
        <Layout>
          <EditSolution />
        </Layout>
      )
    },
    {
      path: '/creators/orders',
      element: (
        <Layout>
          <Orders />
        </Layout>
      )
    },
    {
      path: '/creators/orders/make',
      element: (
        <Layout>
          <MakeSolution />
        </Layout>
      )
    },
    {
      path: '/creators/standard-solutions',
      element: (
        <Layout>
          <StandardSolutionsList />
        </Layout>
      )
    },
    {
      path: '/creators/multi-standard-solutions-upload',
      element: (
        <Layout>
          <MultiStandardSolutionsUpload />
        </Layout>
      )
    },
    {
      path: '/creators/*',
      element: (
        <NotFound />
      )
    },
  ])

  return creatorRoutes;
}

export default CreatorsRoutes;
